/**
 * For requests to the api/v1/<entity> routes, the firebase.json config and cloud proxy
 * handle the routing of requests between production and development environments,
 * so we only include the production host value.
 */

export const BENCHMARKS_SERVICE_HOSTS = {
  production: 'api/v1/benchmarksService',
  local: 'http://localhost:8080/api/v1/benchmarksService',
};

export const DASHBOARD_REPORT_SERVICE_HOSTS = {
  production: 'api/v1/dashboardReport',
  local: 'http://localhost:8080/api/v1/dashboardReport',
};

export const EVENT_API_SERVICE_HOSTS = {
  production: 'api/v1/eventApi',
  local: 'http://localhost:8080/api/v1/eventApi',
};

export const REPORT_FIELD_SERVICE_HOSTS = {
  production: 'api/v1/reportFields',
  local: 'http://localhost:8080/api/v1/reportFields',
};

export const SCHEDULED_REPORTS_SERVICE_HOSTS = {
  production: 'api/v1/scheduledReports',
  local: 'http://localhost:8080/api/v1/scheduledReports',
};
